<template>
  <v-form class="layout py-4">
    <v-flex class="layout align-center justify-end pl-4">
      <div class="mt-1">
        <label class="body-2 text--primary font-weight-medium">
          Показывать кампании
        </label>
      </div>
      <div class="fixed-width-140 ml-4">
        <v-select
          v-model="activeFilter"
          @change="send"
          :items="filtered"
          item-value="value"
          item-text="title"
          height="34"
          class="content-bg--1 v-text-field--noBorder"
          hide-details
          dense
          solo
        >
          <template v-slot:selection="{ item }">
            <div class="ellipsis text-truncate text-no-wrap">
              {{ item.title }}
            </div>
          </template>
        </v-select>
      </div>
    </v-flex>
  </v-form>
</template>

<script>
export default {
  name: "AdvertisingFilter",
  data: () => ({
    /**
     * Values:
     *  0 - отображение всех рекламных кампаний;
     *  1 - отображение активных в данный момент;
     *  2 - отображение запланированных в будущем;
     *  3 - отображение завершенных
     */
    filtered: [
      {
        title: "Все",
        value: 0
      },
      {
        title: "Текущие",
        value: 1
      },
      {
        title: "В планах",
        value: 2
      },
      {
        title: "Завершены",
        value: 3
      }
    ],
    activeFilter: 0
  }),
  mounted() {
    this.activeFilter = this.$store.getters.advFilter;
  },
  methods: {
    send() {
      this.$store.commit("SET_ADV_FILTER", this.activeFilter);
    }
  }
};
</script>
